// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__eEEAJ","title":"Banner_title__NwvDC","slider":"Banner_slider__TKk-u","label":"Banner_label__ynvHS"};